// dependecies import ==>
import React, { useState, useEffect } from "react";
import moment from "moment";
import axios from "axios";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";
import ReplyIcon from "@material-ui/icons/Reply";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
// project file import ==>
import { DateRange } from "react-date-range";
import "./style.scss";
import DocumentContainer from "../UI Component/DocumentViewer/DocumentCotainer";
import ShareManualRxModal from "../ManualRX/ShareManualRxMoadal";
import InfoPopOver from "./InfoPopOver";
import Loader from "../UI Component/Loader/Loader";
// constant import ==>
import { CONSULTATION_TYPE } from "../common/DashboardAccounts/constant";
import {
  GET_PRESCRIPTION_DATES_AND_LIST,
  APPROVE_AND_SHARE_ERX,
} from "./PrescriptionTabAPIHandler/APIconstants";
import {
  getPrescriptionDates,
  getPrescriptionList,
  getSharedManualRxResponse,
  getSharedPrescriptionResponse,
  shareSharedErx,
  approveAndShareRxData,
} from "./PrescriptionTabAPIHandler";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import SkeletonLoader from "../SkeletonLoader";
// <==

const PastPrescription = (props) => {
  const { appointmentData } = props;
  const [showRxModal, setshowRxModal] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [documentShow, setDocumentShow] = useState(false);
  const [fullView, setFullView] = useState(false);
  const [pastPresLoader, setPastPresLoader] = useState(false);
  const defaultDateRange = [
    {
      startDate: new Date(),
      endDate: new Date(),
      rangeColors: "#F969A4",
      color: "#F969A4",
      key: "selection",
      isFilterApplied: false,
      viewStartDate: new Date(),
      viewEndDate: new Date(),
    },
  ];

  const [openPopOver, setOpenPopOver] = useState(false);
  const [viewPrescriptionList, setViewPrescriptionList] = useState({});
  const [disabledDates, setDisabledDates] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const is_staff = localStorage.getItem("user_type");
  const appointment_id = props?.appointmentData?.app_id?.id
    ? props?.appointmentData?.app_id?.id
    : props?.appointmentData?.appointment_id;

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      rangeColors: "#F969A4",
      color: "#F969A4",
      key: "selection",
      isFilterApplied: false,
      viewStartDate: new Date(),
      viewEndDate: new Date(),
    },
  ]);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  // Life cycle

  useEffect(() => {
    PastPrescriptionListAPI();
  }, []);

  // API calls <===

  const PastPrescriptionDatesAPI = async (value) => {
    const startOfMonth = moment(value).startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment(value).endOf("month").format("YYYY-MM-DD");

    let reqPayload = {
      appointment_id: appointment_id,
      is_dates: true,
      start_date: startOfMonth,
      end_date: endOfMonth,
    };
    // if (prescription_id) {
    //   reqPayload["ignore_prescription_id"] = prescription_id;
    // }
    const prescriptionDatesResponse = getPrescriptionDates(
      reqPayload,
      GET_PRESCRIPTION_DATES_AND_LIST
    ); //Fetch API Data
    prescriptionDatesResponse.then(([res, error]) => {
      if (!error) {
        setDisabledDates(res);
      } else {
        setDisabledDates([]);
      }
    });
  };

  const PastPrescriptionListAPI = async (date) => {
    setPastPresLoader(true);
    let start_date = null,
      end_date = null;
    if (date?.length > 0 && date[0]?.isFilterApplied) {
      start_date = moment(date[0].startDate).format("YYYY-MM-DD");
      end_date = moment(date[0].endDate).format("YYYY-MM-DD");
    }
    let reqPayload = {
      appointment_id: appointment_id,
      is_dates: false,
      start_date: start_date, //"2022-09-01",
      end_date: end_date, //"2022-09-30"
    };
    const prescriptionListResponse = getPrescriptionList(
      reqPayload,
      GET_PRESCRIPTION_DATES_AND_LIST
    ); //Fetch API Data
    prescriptionListResponse.then(([res, error]) => {
      if (!error) {
        setViewPrescriptionList(res);
      } else {
        setViewPrescriptionList([]);
      }
      setPastPresLoader(false);
    });
  };

  const SharePrescriptionAPICall = async (data) => {
    setShowLoader(true);
    let reqPayload = {
      "authorizer-principal-id": {
        user_id: userId,
        user_type: "1",
      },
      appointment_id: data.appointment_id,
      prescription_id: data.saved_prescription_id,
    };
    let apiCallForShare = "";
    if (
      data?.consultation_type === CONSULTATION_TYPE.INSTANT ||
      data?.consultation_type === CONSULTATION_TYPE.TELE_CONSULT_FOLLOW_UP ||
      data?.consultation_type === CONSULTATION_TYPE.TELE_CONSULT_REGULAR
    ) {
      apiCallForShare = getSharedPrescriptionResponse(reqPayload);
    } else {
      apiCallForShare = approveAndShareRxData(
        reqPayload,
        APPROVE_AND_SHARE_ERX
      );
    }
    apiCallForShare.then(([res, error]) => {
      if (!error) {
        PastPrescriptionListAPI(dateRange);
        setshowRxModal(true);
      }
      setShowLoader(false);
    });

    // <==
  };

  const ShareManualRXAPICall = async (data) => {
    setShowLoader(true);
    const reqPayload = {
      user_type: is_staff === "staff" ? "4" : "1",
      user_id: is_staff === "staff" ? staffId : userId,
      appointment_id: appointment_id,
      prescriptions: [
        {
          doc_data: data?.document_path,
          file_size: data?.file_size,
          doc_title: data?.doc_title,
        },
      ],
      document_id: data?.prescription_id,
      prescription_status: "edited",
    };
    if (appointmentData?.doctor_id || userId) {
      reqPayload["doctor_id"] = appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : userId;
    }
    const shareManualRXResponse = getSharedManualRxResponse(reqPayload); //Fetch API Data
    shareManualRXResponse.then(([res, error]) => {
      if (!error) {
        setshowRxModal(true);
      }
      setShowLoader(false);
    });
  };

  const ShareSharedErxAPI = async (data) => {
    setShowLoader(true);
    let reqPayload = {
      user_id: is_staff === "staff" ? staffId : userId,
      appointment_id: data.appointment_id,
      prescription_id: data.prescription_id,
    };
    const shareSharedErxResponse = shareSharedErx(reqPayload); //Fetch API Data
    shareSharedErxResponse.then(([res, error]) => {
      if (!error) {
        setshowRxModal(true);
      }
      setShowLoader(false);
    });
  };

  // =====>

  // actions <====
  const handleReset = () => {
    setDateRange(defaultDateRange);
    setOpenPopOver(false);
    PastPrescriptionListAPI();
  };

  const handleFilter = () => {
    let obj = dateRange[0];
    let date = [
      {
        ...obj,
        isFilterApplied: true,
        viewStartDate: obj.startDate,
        viewEndDate: obj.endDate,
      },
    ];
    setDateRange(date);
    setOpenPopOver(false);
    PastPrescriptionListAPI(date);
  };

  const handleShowDatePicker = () => {
    if (!openPopOver === true) {
      if (dateRange?.length > 0 && dateRange[0]?.isFilterApplied) {
        PastPrescriptionDatesAPI(dateRange[0]?.startDate);
      } else {
        PastPrescriptionDatesAPI(new Date());
      }
    }
    setOpenPopOver(!openPopOver);
  };

  // ====>

  const renderDateFilter = () => {
    return (
      <div
        className="past-prescription-filter-container"
        style={{ position: "relative" }}
      >
        <div
          className="past-prescription-filter-btn px-3"
          onClick={handleShowDatePicker}
        >
          <span className="filter-text">
            {dateRange?.length > 0 &&
            dateRange[0]?.isFilterApplied &&
            dateRange[0].viewStartDate &&
            dateRange[0].viewEndDate
              ? moment(dateRange[0].viewStartDate).format("MMMM D,YYYY") +
                " - " +
                moment(dateRange[0].viewEndDate).format("MMMM D,YYYY")
              : "All"}
          </span>{" "}
          <CalendarTodayIcon className="calender-icon" />
        </div>
        {openPopOver && (
          <div className="past-prescription-calender-container">
            <div>
              <DateRange
                dateDisplayFormat="dd/MM/yyyy"
                editableDateInputs={false}
                onChange={(e) => {
                  if (
                    disabledDates.includes(
                      moment(e.selection.startDate).format("YYYY-MM-DD")
                    ) ||
                    disabledDates.includes(
                      moment(e.selection.endDate).format("YYYY-MM-DD")
                    )
                  ) {
                  } else {
                    setDateRange([e.selection]);
                  }
                }}
                moveRangeOnFirstSelection={false}
                ranges={dateRange}
                maxDate={new Date()}
                color="#F969A4"
                startDatePlaceholder="DD/MM/YYYY"
                endDatePlaceholder="DD/MM/YYYY"
                initialFocusedRange={[0, 0]}
                // disabledDates={disabledDate}
                onShownDateChange={(date) => {
                  PastPrescriptionDatesAPI(date);
                }}
                dayContentRenderer={customDayContent}
                showPreview={false}
              />
              <div className="d-flex justify-content-end past-prescription-filter-datepicker-container px-2">
                <button
                  className="prescription-reset-btn"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  className="prescription-filter-btn"
                  onClick={handleFilter}
                >
                  Filter
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  function customDayContent(day) {
    return (
      <div
        className={`${
          disabledDates?.includes(moment(day).format("YYYY-MM-DD"))
            ? "disabled-date"
            : ""
        }`}
        // className={"disabled-date"}
        style={{ width: "-webkit-fill-available" }}
      >
        <span
          style={{
            padding: "9px",
            cursor: `${
              disabledDates?.includes(moment(day).format("YYYY-MM-DD"))
                ? "not-allowed"
                : "pointer"
            }`,
          }}
        >
          {moment(day).format("DD")}
        </span>
      </div>
    );
  }

  const PrescriptionDateRange = () => {
    return (
      <div className="past-prescription-filter-container d-flex justify-content-between">
        <p className="past-prescription-filter-heading">Filter By Date</p>
        <div>{renderDateFilter()}</div>
      </div>
    );
  };

  const PrescriptionList = () => {
    return (
      <div className="past-prescription-list">
        <div className="w-100">
          {Object.entries(viewPrescriptionList)?.length > 0 ? (
            Object.entries(viewPrescriptionList).map(([key, value]) => (
              <>
                <div className="past-prescription-date-and-heading-wrapper">
                  <div className="d-flex justify-content-between past-prescription-date-wrapper">
                    <div className="prescription-date">
                      {moment(key).format("DD MMMM, YYYY")}
                    </div>
                    <div className="prescription-count">
                      {value?.length}{" "}
                      {value?.length === 1 ? "Document" : "Documents"}
                    </div>
                  </div>
                  <>
                    {value.map((list, index) => (
                      <div
                        key={index}
                        className={`d-flex py-3 past-prescription-saved-wrapper ${
                          index + 1 !== value.length
                            ? "prescription-content-wrapper"
                            : ""
                        }`}
                      >
                        <div style={{ width: "60%" }}>
                          <div className="d-flex">
                            <p className="prescription-title mb-1">
                              {list?.doc_type === "erx"
                                ? "E-Prescription" + list?.count
                                : "Manual Prescription" + list?.count}
                            </p>
                            {list?.doc_type !== "erx" && (
                              <span className="d-flex align-items-center">
                                <InfoPopOver data={list} />
                              </span>
                            )}
                          </div>

                          <div className="d-flex">
                            <p className="prescription-time">
                              {moment(list.time).format("hh:mm A")}
                            </p>
                            <span className="prescription-seperator d-flex align-items-center justify-content-center">
                              <FiberManualRecordIcon className="sepeartor-icon" />
                            </span>
                            <span
                              className={`${
                                list?.status === "shared"
                                  ? "prescription-shared"
                                  : "prescription-saved"
                              }`}
                            >
                              {list?.status === "shared" ? "Shared" : "Saved"}
                            </span>
                          </div>
                        </div>

                        <div
                          style={{ width: "40%" }}
                          className="d-flex justify-content-end"
                        >
                          <span
                            className={`${
                              list?.presigned_url_view
                                ? ""
                                : "disable-pointer-event-span"
                            }`}
                            style={{ paddingTop: "4px" }}
                            data-tooltip="View"
                            data-tooltip-conf="bottom"
                          >
                            <i
                              className={`medical-record-icon m-1 +  ${
                                list?.presigned_url_view
                                  ? ""
                                  : "disable-current-icon"
                              }`}
                              onClick={() => {
                                const lastDot =
                                  list?.doc_title?.lastIndexOf(".");
                                const fileType =
                                  list?.doc_title?.substring(lastDot + 1) ||
                                  ".pdf";
                                setFileName(
                                  list?.doc_type === "erx"
                                    ? "E-Prescription" + list?.count
                                    : "Manual Prescription" + list?.count
                                );
                                // setFileType(".pdf");
                                setFileType(fileType);
                                setFileUrl(list?.presigned_url_view);
                                setDocumentShow(true);
                              }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </i>
                          </span>
                          <span
                            className={`${
                              list?.presigned_url
                                ? ""
                                : "disable-pointer-event-span"
                            }`}
                            style={{ paddingTop: "4px" }}
                            data-tooltip="Download"
                            data-tooltip-conf="bottom"
                          >
                            <i
                              className={`medical-record-icon m-1 +  ${
                                list?.presigned_url
                                  ? ""
                                  : "disable-current-icon"
                              }`}
                              onClick={() => {
                                const lastDot =
                                  list?.doc_title?.lastIndexOf(".");

                                const fileType =
                                  list?.doc_title?.substring(lastDot + 1) ||
                                  ".pdf";
                                downloadURI(
                                  list?.presigned_url,
                                  list?.doc_type === "erx"
                                    ? "E-Prescription" + list?.count
                                    : "Manual Prescription" + list?.count,
                                  // ".pdf"
                                  fileType
                                );
                              }}
                            >
                              <GetAppIcon fontSize="small" />
                            </i>
                          </span>
                          <span
                            className={`${
                              list?.presigned_url &&
                              list?.presigned_url_view &&
                              list?.appointment_id &&
                              list?.prescription_id
                                ? ""
                                : "disable-pointer-event-span"
                            }`}
                            style={{ paddingTop: "4px" }}
                            data-tooltip="Share"
                            data-tooltip-conf="bottom"
                          >
                            <i
                              className={`medical-record-icon m-1 +  ${
                                list?.presigned_url &&
                                list?.presigned_url_view &&
                                list?.appointment_id &&
                                list?.prescription_id
                                  ? ""
                                  : "disable-current-icon"
                              }`}
                              onClick={() => {
                                if (list.doc_type === "erx") {
                                  if (list?.status === "shared") {
                                    ShareSharedErxAPI(list);
                                  } else {
                                    SharePrescriptionAPICall(list);
                                  }
                                } else {
                                  ShareManualRXAPICall(list);
                                }
                              }}
                            >
                              <ReplyIcon
                                fontSize="small"
                                style={{ transform: "scaleX(-1)" }}
                              />
                            </i>
                          </span>
                        </div>
                      </div>
                    ))}
                  </>
                </div>
              </>
            ))
          ) : dateRange?.length > 0 &&
            dateRange[0].isFilterApplied &&
            Object.entries(viewPrescriptionList)?.length <= 0 ? (
            <div className="no-data-message d-flex align-items-center justify-content-center">
              No Prescription Found For This Date Range
            </div>
          ) : pastPresLoader ? (
            <SkeletonLoader lines={4} />
          ) : (
            Object.entries(viewPrescriptionList)?.length <= 0 &&
            !pastPresLoader && (
              <div className="no-data-message d-flex align-items-center justify-content-center">
                No Prescription Found
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  const ImagetoPrint = (source) => {
    return (
      "<html><head><scri" +
      "pt>function step1(){\n" +
      "setTimeout('step2()', 10);}\n" +
      "function step2(){window.print();window.close()}\n" +
      "</scri" +
      "pt></head><body onload='step1()'>\n" +
      "<img src='" +
      source +
      "' /></body></html>"
    );
  };

  const downloadURI = async (url, name, fileType) => {
    const blob = await axios.get(url, {
      headers: {
        "Content-Type": "application/octet-stream",
      },
      responseType: "blob",
    });
    const a = document.createElement("a");
    const href = window.URL.createObjectURL(blob.data);
    a.href = href;
    a.download = name + "." + fileType.trim();
    a.click();
  };

  function closeNotification() {
    setDocumentShow(false);
    setFileUrl("");
    setFileName("");
    setFileType("");
    setFullView(false);
  }

  return (
    <>
      {
        <div>
          {showLoader && <Loader />}
          {PrescriptionDateRange()}
          {PrescriptionList()}
        </div>
      }

      {documentShow && (
        <DocumentContainer
          cancelHandler={closeNotification}
          fullViewHandler={() => {
            setFullView(!fullView);
          }}
          url={fileUrl}
          fileName={fileName}
          fileType={fileType}
          // width={width || ""}
        />
      )}

      <ShareManualRxModal
        show={showRxModal}
        handleClose={() => {
          setshowRxModal(false);
        }}
      />
    </>
  );
};

export default PastPrescription;
